import { FC } from 'react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';
import { Button } from '@shared/components/button-new';
import { FileType } from '@shared/components/file-dropzone';
import { SingleFileUploadButton } from '@shared/components/file-upload-button/single-file-upload-button';
import { mimeGroups } from '@shared/constants/common';
import { t } from '@shared/i18n';
import { FileIcon } from '@shared/icons/file';
import { ImageIcon } from '@shared/icons/image';
import { TrashIcon } from '@shared/icons/trash';
import { UploadIcon } from '@shared/icons/upload';
import { colours } from '@shared/theme/colours';
import { ButtonSize, NewButtonColour } from '@shared/types/common/button';
import { parseBytes } from '@shared/utils/file';

import { styles } from './DisposalHeadsOfTermsUpload.styles';

export interface DisposalHeadsOfTermsUploadProps extends WithStyles<typeof styles> {
  file: File | null;
  onFileSelect: (file: File) => void;
  onFileDelete: () => void;
}

const DisposalHeadsOfTermsUploadComponent: FC<DisposalHeadsOfTermsUploadProps> = ({
  classes,
  file,
  onFileSelect,
  onFileDelete,
}) => {
  if (file) {
    const fileSize = parseBytes(file.size, 2);
    const isImage = mimeGroups.images.some((mime) => mime.includes(file.type));

    return (
      <div className={classes.fileContainer}>
        <div className={classes.fileCard}>
          <div className={classes.fileLeft}>
            <span className={classes.fileIcon}>{isImage ? <ImageIcon /> : <FileIcon />}</span>
            <span className={classes.fileName}>{file.name}</span>
          </div>
          <div className={classes.fileRight}>
            <span className={classes.fileSize}>
              {fileSize.amount} {fileSize.unit}
            </span>
            <Button
              colour={NewButtonColour.Ghost}
              size={ButtonSize.small}
              startIcon={<TrashIcon color={colours.neutral[500]} />}
              onClick={onFileDelete}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.placeholder}>
      <h3 className={classes.smallHeading}>{t('no_heads_of_terms_attached')}</h3>
      <h4 className={classes.smallSubHeading}>{t('upload_the_heads_of_terms_to_store_them_securely_here')}</h4>
      <SingleFileUploadButton
        buttonProps={{
          colour: NewButtonColour.PrimaryNavy,
          size: ButtonSize.small,
          startIcon: <UploadIcon />,
          text: t('upload_file'),
        }}
        maxSize={104857600}
        type={FileType.noArchiveFiles}
        onFileSelect={onFileSelect}
      />
    </div>
  );
};

export const DisposalHeadsOfTermsUpload = withStyles(styles)(DisposalHeadsOfTermsUploadComponent);
